<script lang="ts" setup>
import { tpgIconPlayCircleFilled } from '@tpg/grammar-web-icons';

import { GrammarIcon } from '@nora-monorepo/grammar-ui';

import ImagePreview from '#nora-chat-ui/components/open-conversations/messages/message-attachments/message-attachment-preview/ImagePreview.vue';

interface VideoPreviewProps {
  maxSize: number;
  name: string;
  url: string;
  fillFrame?: boolean;
}

defineProps<VideoPreviewProps>();
const emit = defineEmits<{
  refreshUrls: [];
}>();
</script>

<template>
  <div class="relative max-w-full" :class="{ 'h-full': fillFrame }">
    <ImagePreview
      :url="url"
      :name="name"
      :max-size="maxSize"
      :fill-frame="fillFrame"
      @refresh-urls="emit('refreshUrls')"
    />
    <div class="pointer-events-none absolute inset-0 flex items-center justify-center">
      <span class="flex items-center justify-center rounded-full bg-black/60 p-2">
        <GrammarIcon
          :icon-template="tpgIconPlayCircleFilled"
          size="xlarge"
          style="--iconVectorFill: #AAC2CB"
        />
      </span>
    </div>
  </div>
</template>
